//웹->앱

export const sendMessage = (message: string) => {
  window.ReactNativeWebView?.postMessage(message);
};

export const appLog = (data: string) => {
  sendMessage(
    JSON.stringify({
      event: "test",
      params: {
        data: data,
      },
    })
  );
};

export async function sendMessageWithDelay(
  message: string,
  count = 2,
  delay = 100
) {
  for (let i = 0; i < count; i++) {
    sendMessage(message);
    if (i < count - 1) {
      await new Promise((res) => setTimeout(res, delay));
    }
  }
}

export async function notifyAppLogout() {
  if (!window.ReactNativeWebView?.postMessage) return;

  await sendMessageWithDelay(
    JSON.stringify({
      event: "value",
      params: {
        accessToken: "",
      },
    }),
    2,
    50
  );

  await sendMessageWithDelay(
    JSON.stringify({
      event: "set_app_lock",
      params: { isEnabled: "false" },
    }),
    2,
    50
  );

  await sendMessageWithDelay(
    JSON.stringify({
      event: "logout",
    }),
    2,
    50
  );
}

//앱->웹

export const getMessageFromApp = (
  setData: React.Dispatch<React.SetStateAction<any | undefined>>
) => {
  const eventFromApp = (e: MessageEvent<any>) => {
    const data = e?.data;
    if (data == null) return;

    const handleParsed = (parsed: any) => {
      if (
        Array.isArray(parsed) &&
        parsed.every((it) => it && typeof it === "object" && "event" in it)
      ) {
        setData(parsed);
        return true;
      }
      if (parsed && typeof parsed === "object" && "event" in parsed) {
        setData(parsed);
        return true;
      }
      return false;
    };

    if (typeof data === "string") {
      try {
        const parsed = JSON.parse(data);
        if (handleParsed(parsed)) return;
      } catch (error) {
        // ignore non-JSON strings
      }
      return;
    }

    if (handleParsed(data)) return;
  };
  // ios
  window.addEventListener("message", eventFromApp, false);
  // android
  document.addEventListener("message", eventFromApp as EventListener, false);
  return () => {
    window.removeEventListener("message", eventFromApp);
    document.removeEventListener("message", eventFromApp as EventListener);
  };
};
